import JustinFlom from "@/assets/svg/creator-shield/justin-flom.svg";
import Work from "@/assets/svg/creator-shield/work.svg";
import CeoMessage from "@/assets/images/enfinity/ceo-message.png";
import FinalCTA from "@/components/creatorshield/FinalCTA";
import Footer from "@/components/creatorshield/Footer";
import { useEffect } from "react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function CaseStudy() {
  const headingRef = useScrollAnimation({ threshold: 0.2 });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <div className="bg-white pt-[120px] pb-20 px-6 md:px-16">
        <div className="4xl:max-w-[100rem] 4xl:mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side - Content */}
            <div className="flex flex-col gap-8">
              {/* Case Study Badge */}
                <div className="flex items-center gap-2 border border-border w-fit rounded-full px-4 py-2">
                  <img src={Work} alt="Telephone Icon" className="w-5 h-5 my-auto" />
                  <span className="font-normal text-black leading-normal whitespace-nowrap">Case Study</span>
                </div>

              {/* Title */}
              <div ref={headingRef} className="animate-fade-rise">
                <h1 className="text-4xl xs:text-5xl lg:text-6xl font-semibold text-black leading-tight text-center lg:text-left">
                  CreatorShield Protects the{" "}
                  <span className="text-[#FF6B35]">#1 Most Viewed Short</span> on
                  YouTube
                </h1>

                {/* Description */}
                <p className="text-xl text-black leading-[35px] font-normal text-center lg:text-left pt-5">
                  Justin Flom's groundbreaking short surpasses 1.5 billion views
                  with CreatorShield protection
                </p>
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="flex justify-center lg:justify-end">
              <div className="w-full lg:w-[400px] h-[450px] rounded-[20px] overflow-hidden">
                <img
                  src={JustinFlom}
                  alt="Justin Flom"
                  className="w-full h-full object-cover rounded-[20px]"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Section */}
        <div className="pt-24 4xl:max-w-[100rem] 4xl:mx-auto">
          <div className=" ">
            <div className="w-full space-y-10 lg:space-y-16">
              {/* First Paragraph */}
              <p
                className="text-2xl lg:text-3xl text-black font-normal text-left"
                style={{ lineHeight: "1.5" }}
              >
                Los Angeles, CA – CreatorShield, the leading digital rights
                protection platform, is proud to announce that it now safeguards
                the #1 most viewed short video on YouTube, created by renowned
                magician and digital creator, Justin Flom. This groundbreaking
                short video has recently surpassed an astonishing 1.5 billion
                views, solidifying Justin's presence as he grows into the world
                of YouTube expansion via his native Facebook audience.
              </p>

              {/* Quote Section */}
              <div className="bg-[#FF6B35] rounded-[20px] p-12 md:p-14 relative overflow-hidden mx-auto lg:mx-8">
                {/* Decorative Elements */}
                <div className="absolute left-[39px] top-[-57px] w-[61px] h-[139px] bg-white opacity-10"></div>
                <div className="absolute left-[119px] top-[-57px] w-[61px] h-[139px] bg-white opacity-10"></div>

                {/* Quote Text */}
                <p
                  className="text-2xl lg:text-3xl text-white leading-[47px] font-medium mb-12 relative z-10"
                  style={{ lineHeight: "1.5" }}
                >
                  Our mission at CreatorShield is to empower creators by
                  providing them with the tools they need to protect their
                  intellectual property. We are honored to support Justin Flom
                  and to play a role in his continued success. I am personally
                  blown away and beyond proud of Justin and his entire team for
                  pulling this off. Make no mistake, this is not a fluke. His
                  hard work has paid off. As our creators grow, we remain even
                  more committed to upholding the integrity of creators' content
                  and enabling them to thrive by recapturing the stolen
                  reuploads and unlocking passive new income.
                </p>

                {/* Author */}
                <div className="flex items-center gap-5 relative z-10">
                  <img 
                    src={CeoMessage} 
                    alt="Jake W. Jones, CEO" 
                    className="w-16 h-16 rounded-full object-cover"
                  />
                  <div className="flex flex-col">
                    <p className="text-lg lg:text-xl text-white font-semibold">
                      Jake W. Jones
                    </p>
                    <p className="text-xl text-white font-normal">
                      CEO, CreatorShield
                    </p>
                  </div>
                </div>
              </div>

              {/* Second Paragraph */}
              <p
                className="text-2xl lg:text-3xl text-black font-normal text-left"
                style={{ lineHeight: "1.5" }}
              >
                With an ever-growing community of 4,500+ content creators
                turning to CreatorShield for copyright protection, the platform
                continues to set the standard for digital rights management. By
                partnering with industry leaders and leveraging cutting-edge
                technology, CreatorShield ensures that creators can confidently
                share their work with the world, knowing that their intellectual
                property is in safe hands.
              </p>
            </div>
          </div>
        </div>
      </div>
      <FinalCTA />
      <Footer />
    </div>
  );
}
